import { create } from 'zustand'
import type { User } from 'firebase/auth'

// Player auth state. `initial` until the first onAuthStateChanged fires, so
// guards can render nothing instead of flashing the login screen on reload.
//
// Role model (decision 2026-07): usersmatch is a flat PLAYER pool — every player
// both organizes and joins matches, so "organizer"/"searcher" are behaviours, not
// account roles (a match's organizer is just its creator, `match.organizerId`).
// The one elevated role is `admin` (platform moderation / directory), resolved
// from `platform_config/admins.emails` + emailVerified — the SAME mechanism as
// clubmanager's platform-admin — and mirrored here as `isAdmin`.
// See docs/architecture.md § Roles.
type AuthStatus = 'initial' | 'authenticated' | 'unauthenticated'

interface AuthState {
  status: AuthStatus
  user: User | null
  isAdmin: boolean
  setAuth: (user: User | null, isAdmin: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'initial',
  user: null,
  isAdmin: false,
  setAuth: (user, isAdmin) =>
    set({ user, isAdmin: user ? isAdmin : false, status: user ? 'authenticated' : 'unauthenticated' }),
}))
